"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormOpportunityProtocol = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const contact_profile_enum_1 = require("../contact-profile-enum");
const form_opportunity_job_type_1 = require("./form-opportunity-job-type");
const protocol_type_1 = require("./protocol-type");
const form_opportunity_1 = require("./form-opportunity");
let FormOpportunityProtocol = class FormOpportunityProtocol {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Protocol Type' }),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: protocol_type_1.ProtocolTypeEnum,
        nullable: false,
        default: protocol_type_1.ProtocolTypeEnum.DEFAULT,
    }),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "protocolType", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'locale',
        length: 2,
        nullable: false,
    }),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "locale", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        name: 'template',
        length: 256,
        nullable: false,
    }),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "template", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormOpportunityProtocol.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormOpportunityProtocol.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('uuid', {
        name: 'form_opportunity_job_type_id',
        nullable: true,
    }),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "formOpportunityJobTypeId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('uuid', {
        name: 'form_opportunity_id',
        nullable: false,
    }),
    __metadata("design:type", String)
], FormOpportunityProtocol.prototype, "formOpportunityId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => form_opportunity_job_type_1.FormOpportunityJobType, {
        onDelete: 'CASCADE',
        nullable: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'form_opportunity_job_type_id',
    }),
    __metadata("design:type", form_opportunity_job_type_1.FormOpportunityJobType)
], FormOpportunityProtocol.prototype, "formOpportunityJobType", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => form_opportunity_1.FormOpportunity, {
        onDelete: 'CASCADE',
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'form_opportunity_id',
    }),
    __metadata("design:type", form_opportunity_1.FormOpportunity)
], FormOpportunityProtocol.prototype, "formOpportunity", void 0);
FormOpportunityProtocol = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Form Opportunity Protocol',
        nameFunction: (i) => `${i.protocolType}@${i.id}`,
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Unique)(['formOpportunityJobTypeId', 'protocolType', 'locale']),
    (0, typeorm_1.Entity)('form_opportunity_protocol', { schema: 'order_intake_forms' })
], FormOpportunityProtocol);
exports.FormOpportunityProtocol = FormOpportunityProtocol;
//# sourceMappingURL=form-opportunity-protocol.js.map